import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft, MapPin, Search } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Header />
      
      {/* Dark Hero Section */}
      <div className="flex-1 bg-[#2d232e] relative overflow-hidden">
        {/* Background decorations */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#36827f]/10 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#36827f]/5 rounded-full blur-3xl pointer-events-none"></div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-20 relative">
          <div className="text-center">
            {/* 404 Visual */}
            <div className="relative mb-8">
              <div className="text-[150px] sm:text-[200px] font-black text-white/5 leading-none select-none">
                404
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-24 h-24 rounded-full bg-[#36827f]/20 flex items-center justify-center">
                  <MapPin className="w-12 h-12 text-[#36827f]" />
                </div>
              </div>
            </div>

            {/* Message */}
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Page Not Found
            </h1>
            <p className="text-white/60 text-lg mb-10 max-w-md mx-auto">
              The page you're looking for doesn't exist or has been moved. Let us help you find your way.
            </p>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <Link 
                to="/"
                className="flex items-center gap-2 bg-[#36827f] hover:bg-[#2d6f6c] text-white px-8 py-4 rounded-xl font-semibold transition-all shadow-lg shadow-[#36827f]/20"
                data-testid="home-btn"
              >
                <Home className="w-5 h-5" />
                Back to Home
              </Link>
              <button
                onClick={() => window.history.back()}
                className="flex items-center gap-2 text-white/60 hover:text-white transition-colors px-6 py-4"
                data-testid="go-back-btn"
              >
                <ArrowLeft className="w-5 h-5" />
                Go Back
              </button>
            </div>

            {/* Quick Links */}
            <div className="pt-8 border-t border-white/10">
              <p className="text-white/40 text-sm mb-6 flex items-center justify-center gap-2">
                <Search className="w-4 h-4" />
                Looking for something?
              </p>
              <div className="flex flex-wrap items-center justify-center gap-3">
                <Link 
                  to="/routes" 
                  className="px-5 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl text-white/80 hover:text-white text-sm font-medium transition-all"
                >
                  All Routes
                </Link>
                <Link 
                  to="/contact" 
                  className="px-5 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl text-white/80 hover:text-white text-sm font-medium transition-all"
                >
                  Contact Us
                </Link>
                <a 
                  href="tel:+306932421170"
                  className="px-5 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl text-white/80 hover:text-white text-sm font-medium transition-all"
                >
                  Call Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
